<ul class="nav nav-tabs" role="tablist">
  <li *ngFor="let channel of channels" class="nav-item" role="presentation">
    <button (click)="selectChannel(channel)" [ngClass]="{'active': isSelected(channel)}" aria-selected="true"
       class="nav-link" data-bs-toggle="tab" role="tab" data-bs-target="#single-form">{{ channel.code?.toUpperCase() }}</button>
  </li>
</ul>

<div class="tab-content" id="myTabContent">
  <div class="tab-pane fade show active p-3" id="single-form" role="tabpanel">
    <ng-content></ng-content>
  </div>
</div>
